interface VideoWithAudioInfo extends HTMLVideoElement {
	mozHasAudio?: boolean;
	webkitAudioDecodedByteCount?: number;
	audioTracks?: { readonly length: number };
}

export const selectors = {
	externalVideoContainer: '.video--external',
	internalVideoContainer: '.video--internal',
	videoElement: 'video',
	videoConsent: '.video__consent',
};

export const classNames = {
	muted: 'video__audio-trigger--muted',
	videoBlocked: 'blocked',
};

const trackYoutubeIframe = () => {
	// To track user behavior, the iframe API must be included.
	const src = 'https://www.youtube.com/iframe_api';

	// check if already loaded
	if (!document.querySelector(`script[src="${src}"]`)) {
		const script = document.createElement('script');
		script.src = src;
		document.head.appendChild(script);
	}
};

export const videoHasAudio = (video: VideoWithAudioInfo) => {
	return video.mozHasAudio || Boolean(video.webkitAudioDecodedByteCount) || Boolean(video.audioTracks && video.audioTracks.length);
};

export const loadYoutubeIframe = (el: Element) => {
	const container = el.querySelector('.youtube');
	if (!container) return;

	let src = container.getAttribute('data-src');
	if (src) {
		// remove blocked class
		el.classList.remove(classNames.videoBlocked);

		// Update src to autoplay
		//! Important: mute=1 is necessary to autoplay the video
		src = src.replace('autoplay=0', 'autoplay=1');
		src = src.replace('mute=0', 'mute=1');

		// Create iframe
		const iframe = `<iframe src="${src}" frameborder="0" allow="autoplay; accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
		container.innerHTML = iframe;

		// Track iframe
		trackYoutubeIframe();
	}
};
